import PropTypes from "prop-types";
import { Box, Typography, Link, Chip, Stack } from "@mui/material";
import { ENVIRONMENT_CONFIG } from "../../../utils/constant";

export default function Footer({ version = "0", environment = "local" }) {
  const currentYear = new Date().getFullYear();
  const envKey = environment?.toLowerCase();
  const envConfig = ENVIRONMENT_CONFIG[environment] || ENVIRONMENT_CONFIG.prod;

  return (
    <Box component="footer" sx={{px: 3, py: 1.5, borderTop: 1, borderColor: "divider", bgcolor: "#ffffff"}}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={1}
      >
        
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={1}
          flexWrap="wrap"
        >
          <Typography variant="body2" color="text.secondary">© {currentYear}{" "}
            <Box component="span" sx={{ fontWeight: 600 }}>ProScore Technologies</Box>. All rights reserved.
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ display: { xs: "none", sm: "block" } }}> |</Typography>

          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{
              flexWrap: "nowrap",
              whiteSpace: "nowrap"
            }}
          >
            <Link
              href="https://proscore.ai/privacy-policy/"
              target="_blank"
              underline="hover"
              variant="body2"
            >
              Privacy Policy
            </Link>

            <Typography variant="body2" color="text.secondary">
              |
            </Typography>

            <Link
              href="https://proscore.ai/terms-conditions/"
              target="_blank"
              underline="hover"
              variant="body2"
            >
              Terms of Service
            </Link>
          </Stack>
        </Stack>

        {/* RIGHT SIDE */}
        <Stack direction="row" spacing={1} alignItems="center">
          {envConfig.label && (
            <Typography
              variant="body2"
              sx={{ fontWeight: 500, color: envConfig.chip.color }}
            >
              {envConfig.label}
            </Typography>
          )}

          <Chip
            label={`Version: ${version}`}
            size="small"
            sx={{
              fontWeight: 600,
              height: 24,
              ...envConfig.chip
            }}
          />
        </Stack>
      </Stack>
    </Box>
  );
}

Footer.propTypes = {
  version: PropTypes.string,
  environment: PropTypes.string
};